const RECORD_SUSPENSION_STATUS = {
  Normal: { value: 0 },
  Suspended: { value: 1 },
  Retired: { value: 2 }
};

type RECORD_SUSPENSION_STATUS = typeof RECORD_SUSPENSION_STATUS;

export default RECORD_SUSPENSION_STATUS;
